export const CHANGE_SORT = 'CHANGE_SORT';

export const changeSort = field => {
    return {
        type: CHANGE_SORT,
        field
    }
};



// WEBPACK FOOTER //
// ./src/actions/SortActions.js